import { render, staticRenderFns } from "./TopList.vue?vue&type=template&id=3c6674b3&scoped=true&"
import script from "./TopList.vue?vue&type=script&lang=js&"
export * from "./TopList.vue?vue&type=script&lang=js&"
import style0 from "./TopList.vue?vue&type=style&index=0&id=3c6674b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6674b3",
  null
  
)

export default component.exports